import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-bootswatch-select/react-bootswatch-select/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { SvgIcon } from "../gatsby-theme-docz/tools/SvgIcon";
import githubSvg from '../__docz__/images/github.svg';
import demoGif from '../__docz__/images/demo.gif';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <div style={{
      display: 'flex',
      alignItems: 'center'
    }}>
  <div>
    <h1>React Bootswatch Select</h1>
  </div>
  <div>
    <a href="https://github.com/justinmahar/react-bootswatch-select/" target="_blank" rel="noopener noreferrer">
      <SvgIcon src={githubSvg} size={28} style={{
            margin: '0 0 0 20px'
          }} mdxType="SvgIcon" />
    </a>
  </div>
    </div>
    <p><strong parentName="p">{`Bootswatch theme selector component for React. Try Bootswatch themes on your Bootstrap site with one line!`}</strong></p>
    <a href="https://justinmahar.github.io/react-bootswatch-select-demo/" target="_blank" rel="noopener noreferrer">
  <img src={demoGif} style={{
        border: 'solid 1px #eeeeee'
      }} />
    </a>
    <p>{`👁️ `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://justinmahar.github.io/react-bootswatch-select-demo/"
        }}>{`Live Demo`}</a></strong></p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Drop a `}<a parentName="p" {...{
        "href": "https://bootswatch.com/"
      }}>{`Bootswatch`}</a>{` theme selector onto your React site with just one line!`}</p>
    <p>{`This package includes three components:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-bootswatch-select/BootswatchSelect"
        }}>{`BootswatchSelect`}</a>{` - A Bootswatch theme selector that supports three modes: visible, hidden, and display-only.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-bootswatch-select/Bootstrap"
        }}>{`Bootstrap`}</a>{` - A component for easily adding Bootstrap to your site, for convenience.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-bootswatch-select/FontAwesome"
        }}>{`FontAwesome`}</a>{` - A component for easily adding Font Awesome to your site, for convenience.`}</li>
    </ul>
    <p>{`By default, all CSS is loaded from `}<a parentName="p" {...{
        "href": "https://www.bootstrapcdn.com/"
      }}>{`bootstrapcdn.com`}</a>{`.`}</p>
    <h3 {...{
      "id": "features-include"
    }}>{`Features include:`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`🎨 Easily try Bootswatch themes`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Want to quickly skin your Bootstrap site? Drop this component in and try out Bootswatch with one line!`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`🌠 Build beautiful prototypes quickly`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Quickly swatch out your next big project so you can focus on the stuff that matters.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`🎛️ Visible, hidden, and display-only modes`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Several modes for the level of integration that suits you.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`🎁 Quickly drop in `}<a parentName="strong" {...{
            "href": "/react-bootswatch-select/Bootstrap"
          }}>{`Bootstrap`}</a>{` and `}<a parentName="strong" {...{
            "href": "/react-bootswatch-select/FontAwesome"
          }}>{`Font Awesome`}</a></strong>
        <ul parentName="li">
          <li parentName="ul">{`For convenience, Bootstrap and Font Awesome CDN components are included to get you up and running fast.`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm i react-bootswatch-select
`}</code></pre>
    <h2 {...{
      "id": "quick-start"
    }}>{`Quick Start`}</h2>
    <p>{`If Bootstrap is loaded already:`}</p>
    <h4 {...{
      "id": "selector-visible"
    }}>{`Selector Visible`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { BootswatchSelect } from 'react-bootswatch-select';
...
<BootswatchSelect version={'4.4.1'} className="form-control" />
`}</code></pre>
    <p>{`This `}<inlineCode parentName="p">{`select`}</inlineCode>{` will dynamically add the theme CSS link in the `}<inlineCode parentName="p">{`head`}</inlineCode>{` when a Bootswatch style is selected.`}</p>
    <h4 {...{
      "id": "selector-hidden"
    }}>{`Selector Hidden`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { BootswatchSelect } from 'react-bootswatch-select';
...
<BootswatchSelect version={'4.4.1'} selectedThemeName="cerulean" selectorHidden />
`}</code></pre>
    <p>{`This will add the Bootswatch CSS theme selected in the `}<inlineCode parentName="p">{`head`}</inlineCode>{` and not render the `}<inlineCode parentName="p">{`select`}</inlineCode>{` on the page.`}</p>
    <h4 {...{
      "id": "display-only-no-head-link"
    }}>{`Display-Only (No Head Link)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { BootswatchSelect } from 'react-bootswatch-select';
...
<BootswatchSelect className="form-control" disableHeadLink />
`}</code></pre>
    <p>{`This will render the `}<inlineCode parentName="p">{`select`}</inlineCode>{` only and will not dynamically add the selected theme CSS link in the `}<inlineCode parentName="p">{`head`}</inlineCode>{`. It just becomes a plain old `}<inlineCode parentName="p">{`select`}</inlineCode>{`. Use `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` to listen for selection changes.`}</p>
    <h3 {...{
      "id": "bootstrap--bootswatch"
    }}>{`Bootstrap + Bootswatch`}</h3>
    <p>{`If you'd like to load Bootstrap (or Font Awesome) from the CDN before the `}<a parentName="p" {...{
        "href": "/react-bootswatch-select/BootswatchSelect"
      }}>{`BootswatchSelect`}</a>{` is used:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Bootstrap, FontAwesome, BootswatchSelect } from 'react-bootswatch-select';
...
<Bootstrap version={'4.4.1'} />
<FontAwesome version={'4.7.0'} />
<BootswatchSelect version={'4.4.1'} className="form-control" />
`}</code></pre>
    <p>{`All CSS is loaded from `}<a parentName="p" {...{
        "href": "https://www.bootstrapcdn.com/"
      }}>{`bootstrapcdn.com`}</a>{` by default. Check there for the latest version.`}</p>
    <p>{`Font Awesome is not required for `}<a parentName="p" {...{
        "href": "/react-bootswatch-select/BootswatchSelect"
      }}>{`BootswatchSelect`}</a>{`, but is included here in case you want it.`}</p>
    <h2 {...{
      "id": "typescript"
    }}>{`TypeScript`}</h2>
    <p>{`Type definitions have been included for `}<a parentName="p" {...{
        "href": "https://www.typescriptlang.org/"
      }}>{`TypeScript`}</a>{` support.`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`Open source software is awesome and so are you. 😎`}</p>
    <p>{`Feel free to submit a pull request for bugs or additions, and make sure to update tests as appropriate. If you find a mistake in the docs, send a PR! Even the smallest changes help.`}</p>
    <p>{`For major changes, open an issue first to discuss what you'd like to change.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://tinyurl.com/kindlingscripts"
      }}>{`Kindling`}</a>{` for npm script documentation.`}</p>
    <h2 {...{
      "id": "-found-it-helpful-star-it"
    }}>{`⭐ Found It Helpful? `}<a parentName="h2" {...{
        "href": "https://github.com/justinmahar/react-bootswatch-select/stargazers"
      }}>{`Star It!`}</a></h2>
    <p>{`If you found this project helpful, let the community know by giving it a `}<a parentName="p" {...{
        "href": "https://github.com/justinmahar/react-bootswatch-select/stargazers"
      }}>{`star`}</a>{`: `}<a parentName="p" {...{
        "href": "https://github.com/justinmahar/react-bootswatch-select/stargazers"
      }}>{`👉⭐`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      